if($('.team-member-categories').length) {
    let mobileCategoryFiltersButton = $('.mobile-category-filters-toggle'),
        categoryFilterMenu = $('.team-members-category-list'),
        filterOptions = $('.team-members-category-list button');

    mobileCategoryFiltersButton.on('click', function() {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            categoryFilterMenu.slideUp(200);
        } else {
            $(this).addClass('active');
            categoryFilterMenu.slideDown(200);
        }
    });

    filterOptions.on('click', function(e) {
        if($(window).width() < 992) {
            categoryFilterMenu.slideUp(200);
            mobileCategoryFiltersButton.removeClass('active');
        }
    });
}
